import App from "../App";
import GameEvents from "../const/GameEvents";
import GameModel from "../model/GameModel";
import GameLoader from "./GameLoader";
import Layout from "./Layout";
import ConsoleUtil from './ConsoleUtil';

export class FullscreenUtils {
    private isFullscreen: boolean = false;
    private inited: boolean = false;
    private fullscreenAnimation: any = undefined;
    private viewComponent;
    private handImage;
    private arrowImage;
    private closeIcon;

    private resizeHandler;

    init(resizeHandler): void {

        this.resizeHandler = resizeHandler;
        
        let fullscreenParam = "true";
        try {
            fullscreenParam = GameModel.urlParams.fullscreen;
        } catch (error) {
            
        }

        if (!GameModel.isMobile(true) || fullscreenParam == "false") {
                document.body.style.overflow = "hidden";
                return;
            }

        if (this.inIframe()) {
            return;
        }

        this.inited = true;

        this.viewComponent = document.createElement("div");
        this.viewComponent.id = "fullscreen";
        this.fullscreenAnimation = document.createElement("div");
        this.fullscreenAnimation.id = "fullscreenAnimation";

        // Does not support iOS older than 10
        document.body.prepend(this.fullscreenAnimation);
        document.body.prepend(this.viewComponent);

        this.viewComponent.style.display = "none";
        this.fullscreenAnimation.style.display = "none";

        this.checkForFullscreen(true);

        const that = this;

        window.addEventListener("resize", () => {
            setTimeout(() => {
                this.checkForFullscreen();
            }, 0);
        });

        window.addEventListener("touchstart", (e) => {
            if (this.isFullscreen) {
                this.preventDefault(e);
            }
        });

        window.addEventListener("mousedown", (e) => {
            if (this.isFullscreen) {
                this.preventDefault(e);
            }
        });

        window.addEventListener("touchend", () => {
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 300);
        });

        window.addEventListener("mouseup", () => {
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 300);
        });

        //return;

        window.addEventListener("scroll", () => {
            //that.checkForFullscreen();
        });

        window.addEventListener("gesturestart", this.preventDefault);
        window.addEventListener("gesturechange", this.preventDefault);
        window.addEventListener("gestureend", this.preventDefault);
    }

    protected inIframe () {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    protected preventDefault(event) {
        event.preventDefault();
        event.stopPropagation();
    }

    protected checkForFullscreen(initial = false) {
        // this.delayedCheck();
        setTimeout(() => {
            this.delayedCheck(initial)
        }, 300);
    }

    private delayedCheck(initial = false) {
        let height;
        if (Layout.landscape) {
            height = Math.min(window.screen.width, window.screen.height);
        } else {
            height = Math.max(window.screen.width, window.screen.height);
        }

        if (height === window.innerHeight || window.innerHeight / height >= 0.88) {
            /*if (this.isFullscreen === false)*/ {
                this.viewComponent.style.display = "none";
                this.fullscreenAnimation.style.display = "none";
                this.isFullscreen = true;
                
                this.resizeHandler();
            }
        } else {
            /*if (this.isFullscreen === true || initial)*/ {
                this.viewComponent.style.display = "block";
                this.fullscreenAnimation.style.display = "block";
                this.isFullscreen = false;

                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 100);
            }
        }

        ConsoleUtil.logWithColor(
            "[FullscreenUtil] isFullScreen: " +
                this.isFullscreen +
                "\n\theight: " +
                height +
                "\n\twindow.innerHeight: " +
                innerHeight,
            0xe099c8
        );
    }

    public appendHandImages() {
        if(!this.inited) {
            return;
        }
        document.documentElement.style.paddingBottom = "80px";
        /*html {*/
        /*    padding-bottom: 80px;*/
        /*}*/
        let hand = new PIXI.Sprite(GameLoader.loader.resources.hand.texture);
        let image = App.instance.renderer.extract
            .canvas(hand)
            .toDataURL("image/png");
        this.handImage = document.createElement("img");
        this.handImage.src = image;
        this.fullscreenAnimation.appendChild(this.handImage);
        let arrow = new PIXI.Sprite(GameLoader.loader.resources.arrow.texture);
        image = App.instance.renderer.extract
            .canvas(arrow)
            .toDataURL("image/png");
        this.arrowImage = document.createElement("img");
        this.arrowImage.src = image;
        this.fullscreenAnimation.appendChild(this.arrowImage);

        let close = new PIXI.Sprite(GameLoader.loader.resources.close.texture);
        image = App.instance.renderer.extract
            .canvas(close)
            .toDataURL("image/png");

        this.closeIcon = document.createElement("img");
        this.closeIcon.id = "closeIcon";
        this.closeIcon.src = image;
        this.fullscreenAnimation.appendChild(this.closeIcon);
        this.closeIcon.addEventListener("touchend", () => {
            this.enterFullscreen();
        });

        this.closeIcon.addEventListener("mouseup", () => {
            this.enterFullscreen();
        });

        this.positionHandAndArrow();

        App.dispatcher.on(
            GameEvents.ORIENTATION_CHANGED,
            this.positionHandAndArrow,
            this
        );
    }

    disable() {
        this.viewComponent.style.display = "none";
        this.fullscreenAnimation.style.display = "none";
        this.isFullscreen = true;
        this.resizeHandler();
        setTimeout(() => {
            window.scrollTo(0, 0);

            // iOS force resize workaround
            document.body.style.width = (document.body.clientWidth - 1) + "px";
            document.body.style.height = (document.body.clientHeight - 1) + "px";
        }, 100);
    }


    protected positionHandAndArrow() {
        if (Layout.landscape) {
            this.handImage.style.cssText =
                "position: absolute; top: 50%; left: 55%; margin-right: -65%; transform: translate(-50%, -50%); width: 20vw;";
            this.arrowImage.style.cssText =
                "position: absolute; top: 30%; left: 40%; transform: translate(-50%, -50%); width: 10vw;";
            this.closeIcon.style.cssText =
                "position: absolute; top: 0%; right: 0%; margin-right: 0%;margin-top: 9%;  transform: translate(-50%, -50%); width: 7vw;";
        } else {
            this.handImage.style.cssText =
                "position: absolute; top: 50%; left: 65%; margin-right: -65%; transform: translate(-50%, -50%); width: 50vw;";
            this.arrowImage.style.cssText =
                "position: absolute; top: 40%; left: 28%; transform: translate(-50%, -50%); width: 20vw;";
            this.closeIcon.style.cssText =
                "position: absolute; top: 0%; right: 0%; margin-right: 1%;margin-top: 10%;  transform: translate(-50%, -50%); width: 10vw;";
        }
    }

    private async enterFullscreen() {
        try {
            await App.instance.view.requestFullscreen();
        } catch (error) {
        }
        
        this.disable();
    }
}

export default new FullscreenUtils();
